<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column class="pa-12">
                <main :class="{'py-4': $vuetify.breakpoint.smAndDown, 'pa-4': $vuetify.breakpoint.mdAndUp}">
                    <v-breadcrumbs class="pl-0">
                        <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                        <router-link to="/">
                            <v-breadcrumbs-item>
                                <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                            </v-breadcrumbs-item>
                        </router-link>
                    </v-breadcrumbs>
                    <NoteEdit />
                </main>
            </v-layout>
        </div>
        <FooterBlock />
    </div>

</template>


<script>
// import Mainpage from '../components/blocks/News_main/news_main';
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import NoteMain from '../components/blocks/Notifications/notifications_main';
import NoteEdit from '../components/blocks/Notifications/Notifications_edit';
import {mapGetters} from 'vuex';
export default {
  components: {
    HeaderMenu, UserMenu, FooterBlock, NoteMain, NoteEdit,
  },
};
</script>
